import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';

import { isPresent } from 'services/operators';
import { ApplicationConfigService } from 'services/application-config.service';
import { createRequestOption } from 'app/shared/util/request-util';
import { getSpecialPlacePricingItemIdentifier, ISpecialPlacePricingItem } from '../models/special-place-pricing-item.model';

export type EntityResponseType = HttpResponse<ISpecialPlacePricingItem>;
export type EntityArrayResponseType = HttpResponse<ISpecialPlacePricingItem[]>;

@Injectable({ providedIn: 'root' })
export class SpecialPlacePricingItemService {
  protected resourceUrl: string;

  constructor(protected http: HttpClient, protected applicationConfigService: ApplicationConfigService) {
    this.resourceUrl = this.applicationConfigService.getEndpointFor('api/special-place-pricing-items');
  }

  create(specialPlacePricingItem: ISpecialPlacePricingItem): Observable<EntityResponseType> {
    return this.http.post<ISpecialPlacePricingItem>(this.resourceUrl, specialPlacePricingItem, { observe: 'response' });
  }

  update(specialPlacePricingItem: ISpecialPlacePricingItem): Observable<EntityResponseType> {
    return this.http.put<ISpecialPlacePricingItem>(`${this.resourceUrl}/${getSpecialPlacePricingItemIdentifier(specialPlacePricingItem)}`, specialPlacePricingItem, {
      observe: 'response',
    });
  }

  partialUpdate(specialPlacePricingItem: ISpecialPlacePricingItem): Observable<EntityResponseType> {
    return this.http.patch<ISpecialPlacePricingItem>(`${this.resourceUrl}/${getSpecialPlacePricingItemIdentifier(specialPlacePricingItem)}`, specialPlacePricingItem, {
      observe: 'response',
    });
  }

  find(id: number): Observable<EntityResponseType> {
    return this.http.get<ISpecialPlacePricingItem>(`${this.resourceUrl}/${id}`, { observe: 'response' });
  }

  query(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<ISpecialPlacePricingItem[]>(this.resourceUrl, { params: options, observe: 'response' });
  }

  delete(id: number): Observable<HttpResponse<{}>> {
    return this.http.delete(`${this.resourceUrl}/${id}`, { observe: 'response' });
  }

  addSpecialPlacePricingItemToCollectionIfMissing(
    specialPlacePricingItemCollection: ISpecialPlacePricingItem[],
    ...specialPlacePricingItemsToCheck: (ISpecialPlacePricingItem | null | undefined)[]
  ): ISpecialPlacePricingItem[] {
    const specialPlacePricingItems: ISpecialPlacePricingItem[] = specialPlacePricingItemsToCheck.filter(isPresent);
    if (specialPlacePricingItems.length > 0) {
      const specialPlacePricingItemCollectionIdentifiers = specialPlacePricingItemCollection.map(specialPlacePricingItemItem =>
        getSpecialPlacePricingItemIdentifier(specialPlacePricingItemItem)
      );
      const specialPlacePricingItemsToAdd = specialPlacePricingItems.filter(specialPlacePricingItemItem => {
        const specialPlacePricingItemIdentifier = getSpecialPlacePricingItemIdentifier(specialPlacePricingItemItem);
        if (specialPlacePricingItemIdentifier == null || specialPlacePricingItemCollectionIdentifiers.includes(specialPlacePricingItemIdentifier)) {
          return false;
        }
        specialPlacePricingItemCollectionIdentifiers.push(specialPlacePricingItemIdentifier);
        return true;
      });
      return [...specialPlacePricingItemsToAdd, ...specialPlacePricingItemCollection];
    }
    return specialPlacePricingItemCollection;
  }
}
